<script lang="ts">
      import { getLivePreviewContext } from '$lib/components/context/ts/LivePreview.svelte.js'
      import { getPayloadContext } from '$lib/components/context/ts/PayloadGlobals.svelte.js'
      import { getLocaleContext } from '$lib/components/locale/ts/Locale.svelte.js'
      import Metatags from '$lib/components/metatags/Metatags.svelte'
      import ProgramBlock from '$lib/components/program/ProgramBlock.svelte'
      import ProgramItem from '$lib/components/program/ProgramItem.svelte'
      import ProgramItemBlock from '$lib/components/program/ProgramItemBlock.svelte'
      import ProgramListItem from '$lib/components/program/ProgramListItem.svelte'
      import { getHeaderVisiblityContext } from '$lib/ui/menu/index.svelte.js'
      import { getScrollBuffer } from '$lib/utils/scrollBuffer/index.js'
      import { untrack } from 'svelte'

      let { data } = $props()

      function livePreviewOnChange(data: any) {
            const page = data ?? null
            if (page == null) return
            if (page.id) return
            //const scrollBuffer = getScrollBuffer()
            payloadContext.setPage([page], true)
            //requestAnimationFrame( () => scrollBuffer() )
            return
      }

      const payloadContext = getPayloadContext()
      const livePreview = getLivePreviewContext()
      const ui = getHeaderVisiblityContext()
      const locale = getLocaleContext()

      async function setup() {
            payloadContext.setPage(data.page)
            const id = data.id ?  "/" + data.id : ""
            const touple = locale.getLocaleTouple('/program' + id )
            locale.setCurrentPage(touple)
            locale.setLocale(data.locale)

      }

      $effect(() => {
            data
            untrack(() => setup())
      })

      payloadContext.setPage(data.page)

      if (data.page.length == 1) {
            livePreview.registerLivePreview({ livePreview: 'program', onChange: livePreviewOnChange, initialData: data.page[0] })
      }
      ui.forceMenuVisible()

      setup()
</script>


{#if payloadContext.page.length > 1}
      <ProgramBlock items={payloadContext.page}></ProgramBlock>
{:else if payloadContext.page.length == 1}
      <ProgramItemBlock item={payloadContext.page[0]}></ProgramItemBlock>
{/if}
